import { Injectable } from "@angular/core";
declare var cordova;

@Injectable()
export class NetworkTracerNative {

	constructor(
	) {
	}

	traceRoute(url: string): Promise<{ ip: string, data: Array<string> }> {
		return new Promise((resolve, reject) => {
			cordova.plugins.NetworkTracer.traceRoute(url, (response) => {
				resolve(response)
			}, (error) => {
				reject(error)
			});
		})
	}

}



// WEBPACK FOOTER //
// ./src/native/network-tracer.native.ts